import { mdiAccountMultiple } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const Group = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Group"
            path={mdiAccountMultiple}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default Group
